module.exports = __webpack_public_path__ + "assets/img/detail12.fce179be.png";